import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/global-board/images/empty-placeholder.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-col justify-center items-center h-full min-h-screen" }
const _hoisted_3 = {
  key: 1,
  class: "w-full bg-background min-h-screen"
}
const _hoisted_4 = { class: "lg:p-8" }
const _hoisted_5 = { class: "flex flex-row justify-between items-center py-5 p-4" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<span><svg class=\"h-8 w-8 text-primary\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" stroke-width=\"2\" stroke=\"currentColor\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path stroke=\"none\" d=\"M0 0h24v24H0z\"></path><line x1=\"5\" y1=\"12\" x2=\"19\" y2=\"12\"></line><line x1=\"5\" y1=\"12\" x2=\"11\" y2=\"18\"></line><line x1=\"5\" y1=\"12\" x2=\"11\" y2=\"6\"></line></svg></span>", 1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_9 = { class: "flex flex-col lg:flex-row px-4 justify-center lg:justify-start items-center space-y-3 lg:space-y-0" }
const _hoisted_10 = { class: "lg:w-full flex lg:flex-row flex-col w-full lg:bg-white space-y-3 lg:space-y-0 rounded-lg lg:shadow-xl" }
const _hoisted_11 = { class: "flex flex-row w-full w-full shadow-sm lg:shadow-none rounded-lg" }
const _hoisted_12 = { class: "flex flex-row w-full lg:w-full shadow-sm lg:rounded-none lg:shadow-none rounded-lg lg:border-l-2" }
const _hoisted_13 = { class: "flex flex-row w-full mt-8 p-4 space-x-8" }
const _hoisted_14 = { class: "flex flex-col w-full" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col w-full"
}
const _hoisted_17 = { class: "grid lg:grid-cols-3 lg:gap-3 items-center w-full md:grid-cols-2 md:gap-2 sm:grid-cols-2 sm:gap-2 xs:grid-cols-2 xs:gap-2 transition-all ease-in-out delay-250" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = {
  key: 1,
  class: "w-full h-9/12 flex flex-col justify-center items-center min-h-fit animate__animated animate__fadeIn animate__delay-0.4s p-12"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "no results",
  width: "400"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl md:text-3xl lg:text-5xl font-extrabold text-purple-300" }, "No results found")
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "grid lg:grid-cols-3 lg:gap-3 items-center w-full md:grid-cols-2 md:gap-2 sm:grid-cols-2 sm:gap-2 xs:grid-cols-2 xs:gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_CustomSearch = _resolveComponent("CustomSearch")!
  const _component_CompanyCard = _resolveComponent("CompanyCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_PoweredByFooter = _resolveComponent("PoweredByFooter")!

  return (_ctx.isLoadingPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Loader)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_Navbar),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "p-2 hover:bg-primary-light rounded-lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            }, _hoisted_7),
            _createElementVNode("h1", {
              class: _normalizeClass(["lg:text-3xl text-primary font-bold text-2xl", _ctx.branding.accentColor])
            }, " Companies ", 2),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_CustomSearch, {
                  modelValue: _ctx.inputJobValue,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputJobValue) = $event)),
                  class: "bg-white",
                  placeholder: "Search company",
                  onOnSubmit: _ctx.searchByCompanies
                }, null, 8, ["modelValue", "onOnSubmit"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_CustomSearch, {
                  modelValue: _ctx.inputLocationValue,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputLocationValue) = $event)),
                  class: "bg-white",
                  icon: "pin",
                  placeholder: "Search location",
                  onOnSubmit: _ctx.searchByLocation
                }, null, 8, ["modelValue", "onOnSubmit"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (!_ctx.isLoadingCompany)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_ctx.companies.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_CompanyCard, { companies: _ctx.companies }, null, 8, ["companies"])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_Paginator, {
                              modelValue: _ctx.page,
                              page: _ctx.page,
                              pages: _ctx.pagination?.total_pages,
                              "range-size": 1,
                              "onUpdate:modelValue": _ctx.updateHandler,
                              total: _ctx.pagination?.total_count,
                              from: _ctx.pagination?.from,
                              to: _ctx.pagination?.to,
                              class: "mt-8"
                            }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (item, index) => {
                        return _createElementVNode("div", { key: index }, [
                          _createVNode(_component_SkeletonCard, { type: "company" })
                        ])
                      }), 64))
                    ])
                  ]))
            ])
          ])
        ]),
        _createVNode(_component_PoweredByFooter)
      ]))
}